import { CardMenu, CallFullScreenIcon } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';
import { MoreOperateKey } from './type';

export function MoreOperate({
  children,
  container,
  onClick,
}: {
  children: React.ReactNode;
  container?: React.RefObject<HTMLDivElement | null>;
  onClick: (value: string) => void;
}) {
  const items = [
    // {
    //   key: MoreOperateKey.MEET,
    //   label: (
    //     <>
    //       {t('messages.chat.chatMediaCall.screenOperate.sharedScreen')} <MeetingModeIcon />
    //     </>
    //   ),
    // },
    // {
    //   key: MoreOperateKey.MESSAGES,
    //   label: (
    //     <>
    //       Send Messages <CallMessageIcon />
    //     </>
    //   ),
    // },
    // {
    //   key: MoreOperateKey.PARTICIPANTS,
    //   label: (
    //     <>
    //       Participants <CallParticipantsIcon />
    //     </>
    //   ),
    // },
    {
      key: MoreOperateKey.FULL_SCREEN,
      label: (
        <>
          <MyTrans i18nKey="calls.fullScreen" /> <CallFullScreenIcon />
        </>
      ),
    },
    // {
    //   type: 'divider',
    // },
    // {
    //   key: MoreOperateKey.SETTING,
    //   label: (
    //     <>
    //       Setting <CallSettingIcon />
    //     </>
    //   ),
    // },
  ];
  return (
    <CardMenu onClick={onClick} data={items} placement="top" container={container}>
      {children}
    </CardMenu>
  );
}

export default MoreOperate;
